import { Order } from '../models/Order'

import { NetworkService } from '@/services/NetworkService'

interface IUser {
  id: number
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  orders?: Order[]
  ordersPlaced? : Order[]
  roles?: any[]
  createdAt?: Date
}

export class User implements IUser {
  id!: number
  firstName!: string
  lastName!: string
  email!: string
  phoneNumber!: string
  orders!:  Order[]
  ordersPlaced!: Order[]
  roles!: any[]
  createdAt!: Date

constructor(params: IUser) {
  Object.assign(this, params)
}

public static async getUsersByDealer(dealerId: number, search: string): Promise<User[]> {
  const res = await NetworkService.get(
    process.env.VUE_APP_API_BASE_URL +
    '/api/v1/auth/user?dealerId=' + dealerId + '&search=' + search
  )

  const users : User[] = []
  res.data.forEach( (t : any) => {
    let user : User = new User(t)
    users.push(user)
  })

  return users
 }

public static async getUserById(userId: number): Promise<User> {
  const res = await NetworkService.get(
    process.env.VUE_APP_API_BASE_URL + 
    '/api/v1/auth/user/' + userId
  )

  return res.data.user
}

public static async deactivateUser(userId: number) {
  const res = await NetworkService.post(
    process.env.VUE_APP_API_BASE_URL +
    '/api/v1/auth/user/deactivateUser/' + userId
  )

  return res.status
}

}
